export const REQUIREMENTS = [
    'At least 8 characters(s)',
    'At least 1 number(s)',
    'At least 1 symbol(s)',
    'At least 1 lowercase letter(s)',
    'At least 1 uppercase letter(s)'
];

export const executeRules = (newPassword) => {
    if (!newPassword) {
        return [null, null, null, null, null];
    }

    return [
        newPassword.match(/^.{8,}$/) !== null,
        newPassword.match(/[0-9]/) !== null,
        newPassword.match(/[\W]/) !== null,
        newPassword.match(/[a-z]/) !== null,
        newPassword.match(/[A-Z]/) !== null
    ];
}
